/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, inject } from '@angular/core';
import {
    MatDialogRef,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
} from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AuthenticatedUser } from '../../state/auth.model';
import { AuthState } from '../../state/auth.state';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'dash-gis-logout-dialog',
    templateUrl: './logout-dialog.component.html',
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, AsyncPipe],
})
export class LogoutDialogComponent {
    public user$: Observable<AuthenticatedUser> = inject(Store).select(AuthState.user);

    constructor(private store: Store, private dialogRef: MatDialogRef<LogoutDialogComponent>) {}

    public logout() {
        // this.store.dispatch(new BeginLogout());
        this.dialogRef.close(true);
    }
}
